import {DirectoryModel, FileDataModel} from '../../api/types.ts';

// Plain extensions ('png') match file.extension; dotted extensions
// ('sprite.json') match as a file-name suffix so compound formats like
// *.sprite.json can be distinguished from ordinary .json files.
export function matchesExtension(
    file: FileDataModel,
    extensions: string[]
): boolean {
    if (extensions.includes('*')) {
        return true;
    }

    const fileName = (file.fileName || file.name).toLowerCase();

    return extensions.some(extension =>
        extension.includes('.')
            ? fileName.endsWith('.' + extension)
            : extension === file.extension
    );
}

// onlyUnused keeps the files no saved content references (their count is known and 0).
export default function filterDirectory(
    directory: DirectoryModel,
    extensions: string[],
    searchText: string,
    onlyUnused = false
): DirectoryModel | null {
    const filteredFiles = directory.files.filter(
        file =>
            matchesExtension(file, extensions) &&
            (!searchText ||
                file.name.toLowerCase().includes(searchText.toLowerCase())) &&
            (!onlyUnused || file.references === 0)
    );

    const filteredDirectories = directory.directories
        .map(subDir =>
            filterDirectory(subDir, extensions, searchText, onlyUnused)
        )
        .filter((subDir): subDir is DirectoryModel => subDir !== null)
        .filter(
            subDir =>
                subDir.files.length > 0 ||
                subDir.directories.length > 0 ||
                subDir.isNew
        );

    if (
        filteredFiles.length === 0 &&
        filteredDirectories.length === 0 &&
        !directory.isNew
    ) {
        return null;
    }

    return {
        ...directory,
        files: filteredFiles,
        directories: filteredDirectories
    };
}
